import React, {useState} from 'react';

import styles from './MobileCartDelivery.module.css'
import {Button} from "../../../../../ui/General/Button/Button.tsx";
import {MobileDeliveryPickup} from "./components/MobileDeliveryPickup/MobileDeliveryPickup.tsx";
import {DeliveryMethods} from "./components/MobileDeliveryMethod/DeliveryMethods.tsx";
import {MobileDeliveryByCompanies} from "./components/MobileDeliveryByCompanies/MobileDeliveryByCompanies.tsx";
import {Address, DeliveryType} from "../../../../../types/Delivery.interface.ts";
import {Order} from "../../../../../types/Order.interface.ts";
import { DeliveryCourier } from '../components/DeliveryCourier/DeliveryCourier.tsx';

interface Props {
    offer: Order,
    onDeliveryTypeChange: (type: string) => void,
    onDeliveryTransportCompanyChange: (transportCompanyId: number) => void,
    setIsOpenChangeTownModal: (isOpenChangeTownModal: boolean) => void,
    onDeliveryAddressChange: (address: Address) => void,
}


export const MobileCartDelivery: React.FC<Props> = ({
                                                        onDeliveryTypeChange,
                                                        onDeliveryTransportCompanyChange,
                                                        offer,
                                                        setIsOpenChangeTownModal,
                                                        onDeliveryAddressChange,
                                                    }) => {
    const city = {id: offer.delivery.townId, name: offer.delivery.townName};
    const [deliveryType, setDeliveryType] = useState(offer.delivery.type);

    const isPodzamenuPickup = deliveryType === DeliveryType.pickup
    const isPodzamenuCourier = deliveryType === DeliveryType.courier
    const isOthers = deliveryType === DeliveryType.shipping;
    const changeType = (type: string) => {
        onDeliveryTypeChange(type);
        setDeliveryType(type);
    }

    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>1. Где и как вы хотите получить заказ?</h2>
            <div className={styles.main}>
                {
                    isOthers
                    ? <>
                            <div className={styles.cityWrapper}>
                                <div className={styles.cityLabelWrapper}>
                                    <div className={styles.cityLabel}>Ваш город:</div>
                                </div>
                                <div className={styles.city}>
                                    {city.name}
                                    <Button className={styles.btnChoosePoint} style={{marginLeft: 8,}} type='text'
                                            onClick={() => setIsOpenChangeTownModal(true)}>изменить</Button>
                                </div>
                            </div>
                        </>
                        : null
                }
                <div className={styles.outline}/>
                <h3 className={styles.mainTitle}>Выберите способ получения заказа</h3>
                <DeliveryMethods
                    deliveryType={deliveryType}
                    changeType={changeType}
                    offer={offer}
                />

                {
                    isPodzamenuPickup
                        ? <MobileDeliveryPickup />
                        : null
                }
                {isPodzamenuCourier &&
                <DeliveryCourier onDeliveryAddressChange={onDeliveryAddressChange} offer={offer} />}
                {
                    isOthers
                        ? <MobileDeliveryByCompanies
                             onDeliveryTransportCompanyChange={onDeliveryTransportCompanyChange}
                            onDeliveryAddressChange={onDeliveryAddressChange}
                        />
                        : null
                }
            </div>
        </div>
    );
};
